import { useLocale, usePermissions, useTranslate } from 'react-admin';
import { Box, useTheme } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { BackupPanel, backupPanelThemeVars } from '@roommatik/backup-ui';
import { getToken } from '@/utils/auth';
import { PageTitle, SectionHeader } from '@/components/shell';

const isAdmin = (role: string) => role === 'Administrator';

const resolvePanelLocale = (locale: string): 'es-ES' | 'en' =>
  locale === 'es' ? 'es-ES' : 'en';

// The backup control endpoints are mounted at an absolute path on the gateway
// (/api/v1/system/backups), not under the UI-scoped API base (VITE_API_URL ends
// in /api), so derive the origin only.
const apiBase = `${new URL(import.meta.env.VITE_API_URL as string).origin}/api/v1/system/backups`;

const authHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const BackupsPage = () => {
  const t = useTranslate();
  const locale = useLocale();
  const theme = useTheme();
  const { permissions: role, isLoading: roleLoading } = usePermissions<string>();

  // Admin-only — block direct URL bypass; the menu link is already gated.
  if (roleLoading) return null;
  if (!isAdmin(role || '')) return <Navigate to="/" replace />;

  return (
    <Box>
      <SectionHeader
        left={<PageTitle title={t('menu.backups')} subtitle={t('screens.backups.subtitle')} />}
        sticky={false}
      />
      {/* Bridge the host v3 theme into the panel's --rmk-* CSS variables so it
          inherits the warm-neutral surfaces, dark-hairline outline, brand and
          status colours instead of its own fallbacks. */}
      <div style={backupPanelThemeVars(theme)}>
        <BackupPanel
          apiBase={apiBase}
          auth={authHeaders}
          locale={resolvePanelLocale(locale)}
          appName="Ictel.KYC.Gateway"
          onError={(error) => console.error('Backups panel error:', error)}
        />
      </div>
    </Box>
  );
};

export default BackupsPage;
